export default __webpack_public_path__ + "static/media/emptyImage.236f4ef9.svg";